// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

const KICKER = `font-size:11px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:var(--ink-4)`;
const LABEL = `display:flex;flex-direction:column;gap:4px;font-size:11px;font-weight:500;color:var(--ink-4)`;
const FIELD = `height:32px;padding:0 10px;border:1px solid #C8D4EA;border-radius:8px;font-family:inherit;font-size:12px;color:var(--ink);background:#fff;outline:none;box-sizing:border-box`;
const PILL = `flex:none;height:32px;padding:0 14px;border-radius:999px;border:1px solid #C8D4EA;background:#fff;font-family:inherit;font-size:12.5px;color:var(--ink-2);cursor:pointer`;
const TH = `position:sticky;top:0;z-index:1;background:#F5F8FD;padding:10px 12px;border-bottom:1px solid #DCE4F2;font-size:11px;font-weight:500;letter-spacing:0.06em;text-transform:uppercase;color:var(--ink-4);text-align:left;white-space:nowrap`;
const TD = `padding:9px 12px;border-bottom:1px solid #EDF1F8;font-size:12.5px;color:var(--ink);vertical-align:middle;white-space:nowrap`;
const NUM = `text-align:right;font-variant-numeric:tabular-nums`;
const MUTED = `color:var(--ink-4)`;
const COLS = 9;

function Select({ label, value, onChange, all, options, width }) {
  return (
    <label style={sx(LABEL)}>
      {label}
      <select className="gmFocus" value={value} onChange={(e) => onChange(e.target.value)} style={sx(`${FIELD};width:${width}px`)}>
        <option value="">{all}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}

function Chevron({ open }) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" style={{ transform: open ? 'rotate(90deg)' : 'none', transition: 'transform 120ms' }}>
      <path d="M4 2.5 7.5 6 4 9.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function DriverCell({ r }) {
  const extra = r.driverNote || (r.driverKey && r.driverKey !== r.driver ? `(${r.driverKey})` : '');
  return (
    <div title={[r.driver, extra].filter(Boolean).join(' ')} style={sx(`max-width:440px;overflow:hidden;text-overflow:ellipsis`)}>
      {r.driver}
      {extra ? <span style={sx(`${MUTED};font-size:11.5px;margin-left:6px`)}>{extra}</span> : null}
    </div>
  );
}

function Value({ v }) {
  return (
    <div title={v} style={sx(`max-width:280px;margin-left:auto;overflow:hidden;text-overflow:ellipsis`)}>
      {v}
    </div>
  );
}

function Actions({ r }) {
  if (!r.pending) return null;
  return (
    <span style={sx(`display:inline-flex;align-items:center;gap:8px`)}>
      <span style={sx(`font-size:10px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;padding:2px 7px;border-radius:4px;background:#FFF4E5;color:#B25E09`)}>Unsaved</span>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          r.onUndo();
        }}
        style={sx(`${PILL};height:26px;padding:0 10px;font-size:12px`)}
      >
        Undo
      </button>
    </span>
  );
}

function Row({ r }) {
  if (r.kind === 'status') {
    return (
      <tr>
        <td colSpan={COLS} style={sx(`${TD};background:#FAFBFE;padding-left:52px;color:${r.onRetry ? '#E5484D' : 'var(--ink-3)'}`)}>
          {r.text}
          {r.onRetry ? (
            <button type="button" onClick={r.onRetry} style={sx(`${PILL};height:26px;margin-left:12px;font-size:12px`)}>
              Retry
            </button>
          ) : null}
        </td>
      </tr>
    );
  }
  if (r.kind === 'item') {
    const cell = `${TD};background:#FAFBFE;font-size:12px`;
    return (
      <tr>
        <td style={sx(`${cell};box-shadow:inset 2px 0 0 #0052CD`)} />
        <td style={sx(cell)} colSpan={2} />
        <td style={sx(cell)}>{r.channel}</td>
        <td style={sx(cell)}>
          <DriverCell r={r} />
        </td>
        <td style={sx(`${cell};color:var(--ink-3)`)}>{r.month}</td>
        <td style={sx(`${cell};${NUM};color:var(--ink-3)`)}><Value v={r.from} /></td>
        <td style={sx(`${cell};${NUM};font-weight:500`)}><Value v={r.to} /></td>
        <td style={sx(cell)} />
      </tr>
    );
  }
  const group = r.kind === 'group';
  const bg = group && r.open ? 'background:#F5F8FD' : '';
  return (
    <tr
      className={group ? 'gmHover' : undefined}
      onClick={group ? r.onToggle : undefined}
      data-hover={group ? 'background:#F5F8FD' : undefined}
      style={sx(`${bg};${group ? 'cursor:pointer' : ''}`)}
    >
      <td style={sx(`${TD};width:28px;padding-right:0`)}>
        {group ? (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              r.onToggle();
            }}
            aria-expanded={r.open}
            aria-label={r.open ? 'Collapse changes' : 'Expand changes'}
            style={sx(`display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border:none;border-radius:6px;background:transparent;color:var(--ink-3);cursor:pointer`)}
          >
            <Chevron open={r.open} />
          </button>
        ) : null}
      </td>
      <td style={sx(`${TD};color:var(--ink-3);font-variant-numeric:tabular-nums`)}>{r.date}</td>
      <td style={sx(TD)}>{r.user}</td>
      <td style={sx(TD)}>{r.channel}</td>
      <td style={sx(TD)}>
        <DriverCell r={r} />
      </td>
      <td style={sx(`${TD};color:var(--ink-3)`)}>
        {group ? <span style={sx(`display:inline-block;padding:2px 9px;border-radius:999px;background:#E8EEFA;color:#0052CD;font-size:11.5px;font-weight:500`)}>{r.month}</span> : r.month}
      </td>
      <td style={sx(`${TD};${NUM};color:var(--ink-3)`)}><Value v={r.from} /></td>
      <td style={sx(`${TD};${NUM};font-weight:500`)}><Value v={r.to} /></td>
      <td style={sx(`${TD};text-align:right`)}>
        <Actions r={r} />
      </td>
    </tr>
  );
}

export default function ChangeLogScreen({ vm }: { vm: any }) {
  if (!vm.showChangeLog) return null;
  const cl = vm.changeLog;
  const f = cl.filter;

  return (
    <div style={sx(`flex:1;min-height:0;display:flex;flex-direction:column;padding:0 0 24px`)}>
      <div style={sx(`display:flex;align-items:baseline;gap:12px;padding:22px 24px 14px`)}>
        <div style={sx(KICKER)}>Change log</div>
        <span style={sx(`font-size:12.5px;color:var(--ink-3)`)}>{cl.summary}</span>
      </div>

      <div style={sx(`display:flex;flex-wrap:wrap;align-items:flex-end;gap:12px;padding:0 24px 14px`)}>
        <label style={sx(LABEL)}>
          From
          <input type="date" className="gmFocus" value={f.from} max={f.to || undefined} onChange={(e) => cl.setFilter('from', e.target.value)} style={sx(`${FIELD};width:150px`)} />
        </label>
        <label style={sx(LABEL)}>
          To
          <input type="date" className="gmFocus" value={f.to} min={f.from || undefined} onChange={(e) => cl.setFilter('to', e.target.value)} style={sx(`${FIELD};width:150px`)} />
        </label>
        <Select label="User" value={f.user} onChange={(v) => cl.setFilter('user', v)} all="All users" options={cl.users} width={200} />
        <Select label="Channel" value={f.channel} onChange={(v) => cl.setFilter('channel', v)} all="All channels" options={cl.channels} width={170} />
        <Select label="Driver" value={f.driver} onChange={(v) => cl.setFilter('driver', v)} all="All drivers" options={cl.drivers} width={260} />
        {cl.hasFilter ? (
          <button type="button" className="gmHover" onClick={cl.clearFilters} style={sx(PILL)} data-hover="border-color:#0052CD;color:#0052CD">
            Clear filters
          </button>
        ) : null}
      </div>

      <div style={sx(`flex:1;min-height:0;overflow:auto;margin:0 24px;border:1px solid #DCE4F2;border-radius:10px;background:#fff`)}>
        {cl.rows.length ? (
          <table style={sx(`width:100%;border-collapse:separate;border-spacing:0`)}>
            <thead>
              <tr>
                <th style={sx(`${TH};width:28px;padding-right:0`)} />
                <th style={sx(TH)}>Date</th>
                <th style={sx(TH)}>User</th>
                <th style={sx(TH)}>Channel</th>
                <th style={sx(`${TH};width:100%`)}>Driver</th>
                <th style={sx(TH)}>Month / Setting</th>
                <th style={sx(`${TH};text-align:right`)}>From</th>
                <th style={sx(`${TH};text-align:right`)}>To</th>
                <th style={sx(TH)} />
              </tr>
            </thead>
            <tbody>
              {cl.rows.map((r) => (
                <Row key={`${r.kind}:${r.id}`} r={r} />
              ))}
            </tbody>
          </table>
        ) : cl.error ? null : (
          <div style={sx(`padding:28px 24px;font-size:12.5px;color:var(--ink-3)`)}>{cl.empty}</div>
        )}
        {cl.error ? (
          <div style={sx(`display:flex;align-items:center;gap:12px;padding:16px 24px;font-size:12.5px;color:#E5484D`)}>
            {cl.error}
            <button type="button" onClick={cl.onRetry} style={sx(`${PILL};height:28px`)}>
              Retry
            </button>
          </div>
        ) : null}
      </div>

      {cl.hasMore && !cl.error ? (
        <div style={sx(`display:flex;justify-content:center;padding:14px 24px 0`)}>
          <button
            type="button"
            className="gmHover"
            onClick={cl.onMore}
            disabled={cl.loading}
            style={sx(`${PILL};cursor:${cl.loading ? 'default' : 'pointer'}`)}
            data-hover="border-color:#0052CD;color:#0052CD"
          >
            {cl.moreLabel}
          </button>
        </div>
      ) : null}
    </div>
  );
}
